import { Box, Button, Typography, CircularProgress } from "@mui/material";
import FooterNav from "./FooterNav";
import { useEffect, useState } from "react";
import axiosInstance from "../AxiosBaseApi";
import { useNavigate } from "react-router-dom";

const Task = () => {
  const [data, setData] = useState([]);
  const [amountData, setAmountData] = useState([]);
  const [loading, setLoading] = useState(true);  // Loader state
  const navigate = useNavigate();

  const getUserDataAmount = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/planbuylist.php?userid=${id}`
      );
      if (response.status === 200) {
        setAmountData(response.data.plans); 
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const getUserData = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/get_tasks.php?userid=${id}`
      );
      if (response.status === 200) {
        setData(response.data.tasks);
        setLoading(false);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
      getUserDataAmount(token);
    }
  }, []);

  useEffect(() => {
    if (data.length > 0 && amountData.length > 0) {
      setLoading(false);  // Hide the loader once data is fetched
    }
  }, [data, amountData]);

  const handleClick = (item) => {
    navigate(`/detail/${item}`);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          background:
            "#77769e",
        }}
      >
        <Box
          style={{
            height: "8vh",
            display: "flex",
            justifyContent: "center",
            background:  "rgb(62, 62, 62)",
            alignItems: "center",
            padding: "0 14px",
            borderBottom: "0.7px solid #ff9a8e",
          }}
        >
          <Typography variant="body2" color="#fff">
            Task
          </Typography>
        </Box>

        {/* Loader here */}
        {loading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: "13px",
              minWidth: "165px",
              margin: "10px 0",
            }}
          >
            {data?.map((item, ind) => {
              return (
                <div
                  key={ind}
                  onClick={() => handleClick(item.task_id)}
                  style={{
                    display: "flex",
                    position: "relative",
                    width: "100%",
                    margin: "0 10px",
                    alignItems: "center",
                    background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                    borderRadius: "8px",
                    fontSize: "12px",
                    color: "#333",
                    overflow: "hidden",
                    boxShadow:
                      "4px 4px 10px rgb(227 196 196 / 8%), -4px -4px 10px rgb(97 33 33 / 60%)",
                    transition: "all 0.3s ease-in-out",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <img
                    src="/images/newd.jpg"
                    draggable="false"
                    width={"50%"}
                    height={"120px"}
                  />
                  <Box
                    sx={{
                      textAlign: "center",
                      width: "50%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: "#828282", fontWeight: "bold" }}
                    >
                      {item.task_name}
                    </Typography>
                    <Typography sx={{ color: "#666", mb: 1, fontSize: "16px" }}>
                      Commission: <strong>{amountData[0]?.price_per_unit}</strong>
                    </Typography>
                    <Button
                      sx={{
                        px: 2,
                        mb: 1,
                        background: "#f83600",
                        color: "#fff",
                        borderRadius: "20px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        lineHeight: 1,
                        textTransform: "none",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          background:
                            "linear-gradient(to right, rgb(74, 64, 44), rgb(62, 81, 81))",
                        },
                      }}
                    >
                      Rating Now
                    </Button>
                  </Box>
                </div>
              );
            })}
          </div>
        )}

        {/* <img src="images/wallll.jpg" width="100%" alt="img" /> */}
      </div>
      <FooterNav />
    </>
  );
};

export default Task;
